'use client'

import React, { HTMLAttributes, useEffect, useState } from 'react'
import { Loading } from '../Loading';
import parser from 'html-react-parser';
import { HTMLReactParserOptions } from 'html-react-parser';
import Script from 'next/script';
import { cn } from '@/lib/utils';

interface IBookAFlightFormProps extends HTMLAttributes<HTMLDivElement> {
  lang: Locale
};

export const BookAFlightForm: React.FC<IBookAFlightFormProps> = ({ lang }) => {
  const [isLoading, setIsLoading] = useState(true)

  const locale = {
    en: 'en-GB',
    it: 'it-IT',
    de: 'de-DE',
    fr: 'fr-FR',
  }[lang]

  useEffect(() => {
    const skyScannerScript = document.createElement('script');
    skyScannerScript.setAttribute('src', 'https://widgets.skyscanner.net/widget-server/js/loader.js');
    document.head.appendChild(skyScannerScript);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <div className='flex items-center justify-center w-full h-full min-h-[318.594px]'>
      <div
        data-locale={locale}
        className={cn("skyscanner-widget z-[10] w-full", {
          "hidden": isLoading
        })}
        data-skyscanner-widget="SearchWidget"
        data-params="fontColour:#000;buttonColour:#f0be14;buttonFontColour:#fff;">
      </div>
      <Loading isLoading={isLoading} />
    </div>
  )
}
